import React from "react";
import { Typography } from "@mui/material";
import { useGetVersionAdmin } from "../../shared/hooks/useGetMasterData";

function Footer() {
    const [listAdminVersion, _] = useGetVersionAdmin();

    return (
        <Typography variant="body2" color="text.secondary" align="center">
            {"Copyright © "}
            {listAdminVersion.app} {new Date().getFullYear()}
            {"."} All rights reserved | Version {listAdminVersion.version}
        </Typography>
    );
}

export default Footer;
